// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2GDeR23OhxcRu8::after {\n  background-color: #D6ECD2;\n  color: #49852E;\n  content: attr(data-new-string);\n  margin-left: 8px;\n  border-radius: 15px;\n  padding: 2px 8px 2px 8px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addAccountNew": "_2GDeR23OhxcRu8"
};
export default ___CSS_LOADER_EXPORT___;
